'use client'
import React, { HTMLAttributes, useContext } from 'react'
import { ComponentTranslationContext } from '../../../providers/component-translation-provider'
import { MESSAGE_KEYS } from '../../../constants/messageKeys'

export interface FormInputLabelProps extends HTMLAttributes<HTMLLabelElement> {
    name: string
    optional?: boolean
    disabled?: boolean
    children: React.ReactNode
}

export const FormInputLabel = ({ children, name, optional, disabled = false, ...props }: FormInputLabelProps) => {
    const { getLabel } = useContext(ComponentTranslationContext)

    return (
        <label
            {...props}
            className={`form-input-label ${disabled ? 'text-shade-600' : 'text-shade-700'} ${props.className ?? ''}`}
            htmlFor={name}
        >
            {children}
            {optional && <span className="text-shade-600">{` (${getLabel(MESSAGE_KEYS.OPTIONAL)})`}</span>}
        </label>
    )
}
